import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//import ExpandableNavItem from "components/ExpandableNavItem";
import NavItem from "shared/components/NavItem";

export default function MainMenu({ menuLayout, closeMenuHandler }) {
  let location = useLocation();
  useEffect(() => {
    closeMenuHandler && closeMenuHandler();
  }, [location, closeMenuHandler]);

  return (
    <>
      <NavItem
        to="/"
        text={menuLayout.MenuItem1}
        icon={<FontAwesomeIcon icon="home" />}
        //icon="nav-icon fas fa-home"
      />
      <NavItem
        to="/auctions"
        text={menuLayout.MenuItem2}
        icon={<FontAwesomeIcon icon="money-check" />} 
      />
      <NavItem
        to="/procedureType"
        text={menuLayout.MenuItem28}
        icon={<FontAwesomeIcon icon="book-open" />} 
      />
      <NavItem
        to="/directionAnalysis"
        text={menuLayout.MenuItem29}
        icon={<FontAwesomeIcon icon="bars-staggered" />} 
      />
      <NavItem
        to="/analysisSSP"
        text={menuLayout.MenuItem3}
        icon={<FontAwesomeIcon icon="industry" />}
      />
      <NavItem
        to="/analysis"
        text={menuLayout.MenuItem4}
        icon={<FontAwesomeIcon icon="check-square" />}
      />
      <NavItem
        to="/competitorAnalysis"
        text={menuLayout.MenuItem5}
        icon={<FontAwesomeIcon icon="hands-helping" />}
      />
      <NavItem
        to="/indicatorDynamic"
        text={menuLayout.MenuItem6}
        icon={<FontAwesomeIcon icon="chart-line" />}
      />
      <NavItem
        to="/analyticTotal"
        text={menuLayout.MenuItem31}
        icon={<FontAwesomeIcon icon="shapes" />}
      />
      <NavItem
        to="/periodMonitoring"
        text={menuLayout.MenuItem7}
        icon={<FontAwesomeIcon icon="calendar" />}
      />
      <NavItem
        to="/periodMonitoringSSP"
        text={menuLayout.MenuItem8}
        icon={<FontAwesomeIcon icon="calendar-minus" />}
      />
      <NavItem
        to="/participants"
        text={menuLayout.MenuItem9}
        icon={<FontAwesomeIcon icon="users" />}
      />
      <NavItem
        to="/participantsCard"
        text={menuLayout.MenuItem10}
        icon={<FontAwesomeIcon icon="address-card" />}
      />
      <NavItem
        to="/contracts"
        text={menuLayout.MenuItem11}
        icon={<FontAwesomeIcon icon="money-check-alt" />}
      />
      <NavItem
        to="/questions"
        text={menuLayout.MenuItem12}
        icon={<FontAwesomeIcon icon="comments" />}
      />
      <NavItem
        to="/sites"
        text={menuLayout.MenuItem13}
        icon={<FontAwesomeIcon icon="desktop" />}
      />
      <NavItem
        to="/organizers"
        text={menuLayout.MenuItem14}
        icon={<FontAwesomeIcon icon="user-tie" />}
      />
      <NavItem
        to="/organizerCard"
        text={menuLayout.MenuItem15}
        icon={<FontAwesomeIcon icon="id-card" />}
      />
      <NavItem
        to="/organizerResults"
        text={menuLayout.MenuItem33}
        icon={<FontAwesomeIcon icon="arrow-up-wide-short" />}
      />
      <NavItem
        to="/disqualifiedBilling"
        text={menuLayout.MenuItem36}
        icon={<FontAwesomeIcon icon="scale-unbalanced" />}
      />
      <NavItem
        to="/geography"
        text={menuLayout.MenuItem16}
        icon={<FontAwesomeIcon icon="earth-americas" />}
      />
      <NavItem
        to="/bestResults"
        text={menuLayout.MenuItem17}
        icon={<FontAwesomeIcon icon="ranking-star" />}
      />
      <NavItem
        to="/selections"
        text={menuLayout.MenuItem18}
        icon={<FontAwesomeIcon icon="search" />}
      />
      <NavItem
        to="/assets"
        text={menuLayout.MenuItem19}
        icon={<FontAwesomeIcon icon="warehouse" />}
      />
      <NavItem
        to="/assetItems"
        text={menuLayout.MenuItem20}
        icon={<FontAwesomeIcon icon="box-open" />}
      />
      <NavItem
        to="/assetsSSP"
        text={menuLayout.MenuItem21}
        icon={<FontAwesomeIcon icon="university" />}
      />
      <NavItem
        to="/incomeDynamics"
        text={menuLayout.MenuItem22}
        icon={<FontAwesomeIcon icon="money-bill-trend-up" />}
      />
      <NavItem
        to="/leaseRegistry"
        text={menuLayout.MenuItem24}
        icon={<FontAwesomeIcon icon="table" />}
      />
      <NavItem
        to="/leaseContracts"
        text={menuLayout.MenuItem25}
        icon={<FontAwesomeIcon icon="table" />}
      />
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://lease-bi." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem32}</p>
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://land-bi." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem26}</p>
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://privatization-bi." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem34}</p>
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://nps-bi." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem35}</p>
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://green-bi." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem37}</p>
        </a>
      </li>
      <li className="nav-item">
        <a
          className="nav-link jumpapp"
          href={"https://timber." + process.env.REACT_APP_QLIK_LINK_ADDRESS + "/"}
          target="_blank"
          rel="noreferrer"
        >
          <i className="lui-icon  lui-icon--log-in"></i>
          <p>{menuLayout.MenuItem23}</p>
        </a>
      </li>
    </>
  );
}
